<template>
  <div class="user-row mt-2">
    <div class="user-bubble">
      <div class="message-content">{{ message.content }}</div>
      <div class="time-row">
        <span class="time-text">{{ formatTime(message.createdAt) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AIUserMessage',

  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({
        content: '',
        createdAt: '',
        role: 'User',
      }),
    },
  },

  methods: {
    formatTime(dateTime) {
      if (!dateTime) return ''
      const now = moment()
      const messageTime = moment(dateTime)
      if (now.diff(messageTime, 'minutes') < 1) return 'Agora'
      if (now.diff(messageTime, 'hours') < 1) return `${now.diff(messageTime, 'minutes')} min`
      if (now.diff(messageTime, 'days') < 1) return messageTime.format('HH:mm')
      return messageTime.format('DD/MM HH:mm')
    },
  },
}
</script>

<style scoped>
.user-row {
  display: flex;
  justify-content: flex-end;
  animation: fadeSlideIn 0.25s ease-out;
}

.user-bubble {
  max-width: 80%;
  background: #fff;
  color: #333;
  border-radius: 16px 16px 4px 16px;
  padding: 10px 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.message-content {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.5;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.time-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.time-text {
  font-size: 10px;
  opacity: 0.5;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
